import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const getAlerts = () =>
  swRequest({
    path: "/api/users/get_alerts",
  });
